import store from '@/store'
import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import i18n from '@/libs/i18n'
import { ref } from '@vue/composition-api'
import { useLambda } from '@/views/habit/awsLambda'
import { oid, date } from '@/helpers/mongoHelpers'

export default function useRoleAdd() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { router } = useRouter()
  const { createItem } = useLambda()
  const userData = store.state?.userStore?.userData
  const isSubmitting = ref(false)
  const collection = 'role'

  const storeData = async payload => {
    isSubmitting.value = true

    payload.client_id = oid(userData.client.$oid)
    payload.subroles = payload.subroles?.map(e => oid(e)) || []
    payload.parentRoles = payload.parentRoles?.map(e => oid(e)) || []

    try {
      await createItem({ collection, payload })
      showSuccessMessage(i18n.t('message.form_success'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.role_error'))
    } finally {
      router.push({ name: 'organization-role-list' })
      isSubmitting.value = false
    }
  }

  return {
    storeData,
    isSubmitting,
  }
}
